import * as React from 'react';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import { actvtyOpts, deliveryV2Cargo, SEARCH_ACTIVITY, delivery, branchTransfer, branchTransferReceive } from './common/constants';
import DropDown from './common/dropDown';
import { capitalizeFirst } from './common';
import * as inputId from '../components/common/bookingElementId';
import { paymentModes } from './common/paymentsMode';
import { AM_TOURS_AND_TRAVELS, BHARAT_TOURIST, BLUE_BIRD, DADA_BROTHERS, DASHMESH, DEMO_COMPANY, DNR, GOLINK, JAIN_BABA, JAIN_COMPANY_ID, JAIN_NEW, JAIN_PARSHWANTH, KANKAR_ROADWAYS, LAXMI_HOLIDAYS, MAHAVEER, MODI_PARAS, R_S_YADAV, RAJDEEP, RISHABH_COMPANY_ID, RM_LOGISTICS, ROYAL_TRAVEL_AMR, ROYAL_TRAVELS, SHATABDI_BANSWARA, SHREE_LAXMI_YATRA, SHRI_BABU, SRJ_LOGISTICS, STA_COMPANY_ID, STA_RAJKOT_OFFLINE_BRANCH_ID } from '../helper/companyIdhardcode';
import { useAtom, useAtomValue } from 'jotai';
import { CargoRoleRightsAtom, ownCityBranchListAtom } from './common/jotaiState/commonStateAtoms';
import useToken from './helpers/useTokens';
const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

export default function ActivityStack() {
    return (
        <div>
            <Stack
                direction="row"
                divider={<Divider orientation="vertical" flexItem />}
                spacing={2}
            >
                <Item>Item 1</Item>
                <Item>Item 2</Item>
            </Stack>
        </div>
    );
}

export function GetActivityUI(val = '', isOnlyDelivery = false,) {
    const { loginData } = useToken()
    const [roleRigths] = useAtom(CargoRoleRightsAtom)
    const ownBranchList = useAtomValue(ownCityBranchListAtom)
    const IsOfflineBooking = [
      DEMO_COMPANY,
      MODI_PARAS,
      JAIN_COMPANY_ID,
      JAIN_NEW,
      JAIN_BABA,
      DASHMESH,
      BLUE_BIRD,
      RAJDEEP,
      RISHABH_COMPANY_ID,
      MAHAVEER,
      JAIN_PARSHWANTH,
      RM_LOGISTICS,
      GOLINK,
      SRJ_LOGISTICS,
      AM_TOURS_AND_TRAVELS,
      SHREE_LAXMI_YATRA,
      SHATABDI_BANSWARA,
      BHARAT_TOURIST,
      LAXMI_HOLIDAYS,
      DNR,
      KANKAR_ROADWAYS,
      R_S_YADAV,
      SHRI_BABU,
      ROYAL_TRAVEL_AMR,
      DADA_BROTHERS,
    ].includes(loginData.intCompanyID)
    const enableBranchID=[STA_RAJKOT_OFFLINE_BRANCH_ID].includes(loginData.intBranchID)
    let options = []
    const data = roleRigths?.Table?.filter((val, i) => val.Allowed === 1)
    let actOpt = isOnlyDelivery ? actvtyOpts : loginData?.intCompanyID === STA_COMPANY_ID ? actvtyOpts?.filter((obj) => obj.id !== 6) : actvtyOpts?.filter((obj) => obj.value !== deliveryV2Cargo)
    const allowOffline =IsOfflineBooking || (loginData?.intCompanyID === STA_COMPANY_ID && enableBranchID)
    actOpt = allowOffline ? actOpt : actOpt.filter((item) => item.value !== 'Offline Booking')
    for (var i = 0; i < actOpt?.length; i++) {
        for (var y = 0; y < data?.length; y++) {
            if (actOpt[i].id === data[y].BookingRightsID) {
                if (data[y]?.BookingRightsID == 1 || data[y]?.BookingRightsID == 6) {
                    const payTypeData = paymentModes.filter((val) => data[y][val.roleRightsId] === 1);
                    if (payTypeData?.length > 0) {
                        options.push(isOnlyDelivery && actOpt[i].value === deliveryV2Cargo ? delivery : actOpt[i].value)
                    }
                } else {
                    options.push(isOnlyDelivery && actOpt[i].value === deliveryV2Cargo ? delivery : actOpt[i].value)
                }
            }
        }
    }
    if (ownBranchList.length < 2) {
      options = options.filter((option) => ![branchTransfer, branchTransferReceive].includes(option))
    }
    return (
        <Item sx={{ width: '100%', boxShadow: 'none' }}>
            <DropDown
                type={SEARCH_ACTIVITY}
                label={"Activity"}
                data={options}
                width="100%"
                value={capitalizeFirst(val === deliveryV2Cargo ? delivery : val)}
                defaultvalue={capitalizeFirst(val === deliveryV2Cargo ? delivery : val)}
                searchPlaceholder={"Search Activity"}
                makeAlwaysSelected={true}
                tabIndex="1"
                id={inputId.activityType}
                disabled={isOnlyDelivery}
                nextId={val == options.delivery ? "" : val == options.branchTransfer ? "" : inputId.destcity}
            />
        </Item>
    )
}